import React, { useEffect, useState } from 'react';
import { accessService } from '../../../services/central-api/access';
import { translate } from '../../../services/translate';
import FilterDropdown from '../../../components/Filter/components/FilterDropdown';

type Props = {
    actingBodyId?: number | null;
    zIndex: number;
    disabled?: boolean;
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
};

function ActingBodyUnitsDropdown({ value, setValue, zIndex, actingBodyId, disabled }: Props) {
    const [selectableActingBodyUnits, setSelectableActingBodyUnits] = useState<{ label: string; value: number; }[]>([]);

    async function getActingBodyUnits(actingBodyId: number) {
        try {
            const actingBody = await accessService.getActingBody(actingBodyId);

            if (!actingBody.actingBodyUnits) {
                setSelectableActingBodyUnits([]);
            } else {
                setSelectableActingBodyUnits(
                    actingBody.actingBodyUnits.map((unit) => ({
                        value: unit.id || 0,
                        label: unit.name,
                    }))
                );
            }
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        if (actingBodyId && actingBodyId > 0) {
            getActingBodyUnits(actingBodyId);
        } else {
            setSelectableActingBodyUnits([]);
        }
    }, [actingBodyId]);

    return (
        <FilterDropdown
            label={translate('unit')}
            items={selectableActingBodyUnits}
            multiple={true}
            setValue={setValue}
            mode='BADGE'
            value={value}
            zIndex={zIndex}
            disabled={disabled || !actingBodyId}
        />
    );
}

export default ActingBodyUnitsDropdown;
